<template>
  <div class="public-header-container">
    <div class="public-header" :class="{'bg-opacity': headerOpacity}">
      <div class="public-header-center">
        <div class="public-header-icon"></div>
        <div>
          <router-link class="public-header-title fs20" :class="{'default-cursor': activeBar === 'home'}" to="/">教育云开放平台</router-link>
        </div>
        <ul class="public-header-nav">
          <!-- <li :class="{'active': activeBar === 'home'}" @click="changBar(0)">首页</li> -->
          <li @click="changBar(4)" :class="{'active': currentRouteName === 'baseDocument'}">
            <router-link class="header-item" to="/baseDocument">基础文档</router-link>
          </li>
          <li @click="changBar(4)"
            class="css-dropdown-wrap"
            :class="{'active': ['ssoDocument', 'apiDocument', 'miniProgramDocument', 'dataExchangeDocument'].indexOf(currentRouteName) !== -1}">
            <span class="public-header-dropdown-link header-item">
                <span>服务能力</span>
                <i class="el-icon-caret-bottom"></i>
              </span>
              <div class="css-dropdown-items">
                <div class="nav-dropdown-link"
                  :class="{'selected': currentRouteName === 'ssoDocument'}"
                  @click="$router.push({ name: 'ssoDocument'})">
                  统一用户认证
                </div>
                <div class="nav-dropdown-link"
                  :class="{'selected': currentRouteName === 'apiDocument'}"
                  @click="$router.push({ name: 'apiDocument'})">
                  API接入
                </div>
                <div class="nav-dropdown-link"
                  v-if="isShowDataExchange"
                  :class="{'selected': currentRouteName === 'dataExchangeDocument'}"
                  @click="$router.push({ name: 'dataExchangeDocument'})">
                  数据互操作
                </div>
              </div>
            <!-- <el-dropdown class="public-header-item" :show-timeout="50">
              <span class="public-header-dropdown-link header-item">
                <span>服务能力</span>
                <i class="el-icon-caret-bottom"></i>
              </span>
              <el-dropdown-menu class="public-header-menu" slot="dropdown">
                <div class="nav-dropdown-link"
                  :class="{'selected': currentRouteName === 'ssoDocument'}"
                  @click="$router.push({ name: 'ssoDocument'})">
                  统一用户认证
                </div>
                <div class="nav-dropdown-link"
                  :class="{'selected': currentRouteName === 'apiDocument'}"
                  @click="$router.push({ name: 'apiDocument'})">
                  API接入
                </div>
                <div class="nav-dropdown-link"
                  :class="{'selected': currentRouteName === 'miniProgramDocument'}"
                  @click="$router.push({ name: 'miniProgramDocument'})">小程序</div>
                <div class="nav-dropdown-link no-border"
                  :class="{'selected': currentRouteName === 'dataExchangeDocument'}"
                  @click="$router.push({ name: 'dataExchangeDocument'})">数据交换</div>
              </el-dropdown-menu>
            </el-dropdown> -->
          </li>
          <li :class="{'active': currentRouteName === 'standardDocument'}"
            @click="$router.push({ name: 'standardDocument'})">
            <span class="header-item">平台规范</span>
          </li>
          <li :class="{'active': currentRouteName === 'appendixDocument'}"
            @click="$router.push({ name: 'appendixDocument'})">
            <span class="header-item">附录</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
 import * as CommonAPI from "@/api/common-api.js";
 import {rootUrl,ReturnCode} from '@/common/js/config'
  export default {
    data () {
      return {
        headerOpacity: false, // 背景是否透明
        activeBar: 'document',
        currentRouteName: '',
        isShowDataExchange: false
      }
    },
    created() {
      this._getExchangeMenuEnable();
    },
    mounted () {
      this.currentRouteName = this.$route.name
    },
    watch: {
      '$route.name': function (name) {
        this.currentRouteName = name
      }
    },
    methods:{
      changBar () {},
      _getExchangeMenuEnable() {
        let that = this;
        CommonAPI.getExchangeMenuEnable()
        .then(res => {
          if (res.code == ReturnCode.success) {
           that.isShowDataExchange = res.data;
          }
        })
        .catch(err => {
        });
      },
    },
  }
</script>

<style scoped>
.public-header-menu {
  padding: 0;
  margin-top: -2px;
}
.public-header .el-dropdown {
  margin-top: 0;
}
.public-header-dropdown-link {
  display: block;
}
.nav-dropdown-link {
  width: 104px;
  line-height: 35px;
  border-bottom: 1px solid #f1f2f1;
  padding-left: 20px;
  cursor: pointer;
  font-size: 14px;
}
.nav-dropdown-link.selected {
  color: #047cec;
}
.nav-dropdown-link:hover {
  color: #047cec;
}
.nav-dropdown-link.no-border {
  border-bottom: none;
}
.css-dropdown-items {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
  color: #606266;
  background: #fff;
  position: absolute;
  top: 52px;
  left: 0;
  right: 0;
  z-index: 999;
  display: none;
}
.css-dropdown-wrap:hover .css-dropdown-items {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/public-header/document-header.vue